<div class="registration-confirmation-page" *ngIf="registrationRequest; else accessOptions">
  <section class="registration-confirmation" aria-live="polite">
    <div class="confirmation-summary">
      <svg class="confirmation-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M6 2l.01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6zm10 14.5V20H8v-3.5l4-4 4 4z" />
      </svg>
      <h1 class="ewrs-page-title">Application in progress</h1>
      <p class="confirmation-copy">
        Your application has been successfully submitted and is awaiting manager review. You will receive an email
        notification once a decision has been made.
      </p>
    </div>

    <section class="registration-details" aria-labelledby="accessRegistrationDetailsTitle">
      <h2 class="ewrs-section-title" id="accessRegistrationDetailsTitle">Registration details</h2>
      <div class="registration-details-rule" aria-hidden="true"></div>

      <dl class="request-details">
        <div class="request-detail-row">
          <dt>Full name</dt>
          <dd>{{ registrationRequest.fullName || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row">
          <dt>Email</dt>
          <dd>{{ registrationRequest.email || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row">
          <dt>Reporting manager</dt>
          <dd>{{ registrationRequest.reportingManager || registrationRequest.managerEmail || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row">
          <dt>Division</dt>
          <dd>{{ registrationRequest.division || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row" *ngIf="registrationRequest.delegates?.length">
          <dt>Delegates</dt>
          <dd>
            <span *ngFor="let delegate of registrationRequest.delegates; let last = last">
              {{ delegate.name || delegate.email }}<span *ngIf="!last">, </span>
            </span>
          </dd>
        </div>
      </dl>
    </section>
  </section>
</div>

<ng-template #accessOptions>
  <div class="content-margin registration-options-page">
    <section class="registration-options-content">
      <h1 class="ewrs-page-title">Welcome to Employee Workspace Reservation System (EWRS) registration</h1>

      <div class="ontario-alert ontario-alert--informational" role="alert">
        <span class="ontario-alert__icon" aria-hidden="true">
          <img src="assets/images/ontario-icon-alert-information.svg" alt="" />
        </span>
        <div class="ontario-alert__content">
          <h2 class="ontario-alert__title">You don't have access to EWRS</h2>
          <p>Your account has not been added to the Employee Workspace Reservation System (EWRS).</p>
        </div>
      </div>

      <p class="intro-copy">
        To obtain access to EWRS, choose one of the options below. You can submit a self-registration request for
        manager approval or contact the EWRS team to request access directly.
      </p>

      <div class="registration-option-list">
        <article class="registration-option registration-option--interactive" *ngIf="showSelfRegistrationOption">
          <mat-icon class="registration-option-icon" fontSet="material-symbols-outlined" aria-hidden="true">
            how_to_reg
          </mat-icon>
          <div class="registration-option-copy">
            <h2 class="ewrs-section-title">Self-registration</h2>
            <p>
              Submit a registration request for manager approval. Your manager will have up to two weeks to review the
              request, and you will receive an email notification once a decision has been made.
            </p>
          </div>
          <button mat-raised-button color="primary" type="button" (click)="registerNow()">Register now</button>
        </article>

        <article class="registration-option registration-option--contact">
          <mat-icon class="registration-option-icon" fontSet="material-symbols-outlined" aria-hidden="true">
            mark_email_unread
          </mat-icon>
          <div class="registration-option-copy">
            <h2 class="ewrs-section-title">Contact EWRS team</h2>
            <p>
              Request access by emailing {{ supportEmail }} with the subject line "EWRS Access Request" and include:
            </p>
            <ul>
              <li>Your full name</li>
              <li>Your cluster and division</li>
              <li>Your manager's name.</li>
            </ul>
          </div>
        </article>
      </div>
    </section>
  </div>
</ng-template>
